// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__29GUl","list":"BalanceDue_list__1NNBK","listRow":"BalanceDue_listRow__1U691","total":"BalanceDue_total__3ZxB-"};